import MarketplaceFaq from './MarketplaceFaq';

export default MarketplaceFaq;
